<template>
  <div
    class="show-answer"
    :style="getMargin"
  >
    <div
      v-for="answer in answers"
      class="answer"
    >
      <span :class="getIconClass(answer.answer)" /> {{ answer.percentage }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'LikeQuestionResult',
  props: {
    answers: { required: true },
    hasMargin: { default: true },
  },
  computed: {

    getMargin () {
      if (this.hasMargin == true) {
        return ''
      } else {
        return 'margin-left:20px'
      }
    },

  },
  methods: {
    getIconClass (answer) {
      return answer == 'agree' ? 'fa fa-thumbs-o-up' : 'fa fa-thumbs-o-down'
    },
  },
}
</script>

<style scoped>
    .answer {
        min-width:100px !important;
        margin-right: 20px;
        display: inline-block;
    }

    .show-answer {
        display: inline-block;
    }
</style>
